import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import CoverImageControls from './CoverImageControls';
import { getCoverImageAttributes } from '../../DeviationViews/Thumb/helpers';
import s from './CoverImage.scss';
export var CoverImage = function (_a) {
    var className = _a.className, deviation = _a.deviation, children = _a.children, onChange = _a.onChange;
    return (React.createElement("div", tslib_1.__assign({ className: classnames(s['root'], className) }, getCoverImageAttributes({
        deviation: deviation,
        width: 1000,
        height: 380,
        allowHuge: true,
    })),
        children,
        React.createElement(CoverImageControls, { deviation: deviation, onChange: onChange })));
};
CoverImage.displayName = 'CoverImage';
export default CoverImage;
//# sourceMappingURL=CoverImage.js.map